// extracted by mini-css-extract-plugin
export default {"row":"RowData_row__dQqne","room":"RowData_room__rsNYV"};